import { graphql } from "gatsby";
import React from "react";
import iconSwitch from "../images/icon-switch.svg";
import { LanguageSelectorLanguageFragment, Locale } from "../../graphql-types";
import useDomainPath from "../hooks/useDomainPath";
import * as styles from "./language-selector.module.css";

type Props = {
  languages: LanguageSelectorLanguageFragment[];
};

export default function LanguageSelector({ languages }: Props) {
  /**
   * This component assumes that there are only two languages.
   * We will need to refactor this in the future if a site has more than two.
   */
  const currentLang = useDomainPath();
  const altLang = languages.find((x) => x.path !== currentLang);
  if (!altLang) {
    throw new Error("Could not find the alternative language!");
  }

  const { locale, name, path } = altLang;
  const flag = getFlag(locale);
  return (
    <a className={styles.languageSelector} href={path}>
      {flag && (
        <img
          alt=""
          className={styles.languageSelector__flag}
          data-placeholder-image
          src={flag}
        />
      )}
      {name}
      <span className={styles.languageSelector__switch}>
        <img alt="" data-placeholder-image src={iconSwitch} />
      </span>
    </a>
  );
}

function getFlag(locale: Locale): string | undefined {
  return {
    [Locale.EN_GB]: "/images/flag-uk.png",
    [Locale.FR_FR]: "/images/flag-france.png",
  }[locale];
}

export const fragments = {
  languages: graphql`
    fragment LanguageSelectorLanguage on Language {
      locale
      name
      path
    }
  `,
};
